export enum PaymentOption {
	PARTIAL_DEPOSIT = 'PARTIAL_DEPOSIT',
	PAYMENT_ON_ARRIVAL = 'PAYMENT_ON_ARRIVAL',
	PAYMENT_UPFRONT = 'PAYMENT_UPFRONT',
}
